import { css } from '@emotion/react'
import { Spacing } from '@opallabs/gem'
import { singleSelectSelectors, textInputSelectors } from '@opallabs/lapidary'

const rootClass = 'satellite-multi-input'
export const classes = {
  container: rootClass,
  legend: `${rootClass}-legend`,
  options: `${rootClass}-select`,
  value: `${rootClass}-value`,
} as const

// Indent plain text elements to visually line up with `<input>`
const INLINE_TEXT_INSET = Spacing.XS / 2

// @note The `order` monkeying and `flex-basis` on the error message allow the error message to be forced to a second
// line so it displays under the text input.
export const container = css({
  border: 'none',
  columnGap: Spacing.XS * 3,
  display: 'flex',
  flexWrap: 'wrap',
  margin: 0,
  padding: 0,

  legend: {
    paddingInlineStart: INLINE_TEXT_INSET,
  },
  [`.${singleSelectSelectors.root}`]: {
    flexGrow: 1,
  },
  [`.${textInputSelectors.container}`]: {
    inlineSize: Spacing.M * 4,
    order: 1,
  },
  [`.${textInputSelectors.input}`]: {
    minInlineSize: 0,
  },
  [`.${classes.options}`]: {
    order: 2,
  },
  [`.${textInputSelectors.errorMessage}`]: {
    flexBasis: '100%',
    marginBlockStart: Spacing.S,
    order: 3,
    paddingInlineStart: INLINE_TEXT_INSET,
  },
})
